import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("mask", {
      id: "i-348431439__a",
      width: "24",
      height: "24",
      x: "0",
      y: "0",
      maskUnits: "userSpaceOnUse",
      style: {"mask-type":"alpha"}
    }, [
      _createElementVNode("path", {
        fill: "#d9d9d9",
        d: "M0 0h24v24H0z"
      })
    ], -1),
    _createElementVNode("g", { mask: "url(#i-348431439__a)" }, [
      _createElementVNode("path", {
        fill: "#1c1b1f",
        d: "M7 18a.97.97 0 0 1-.713-.288A.97.97 0 0 1 6 17v-2h13V6h2q.424 0 .712.287Q22 6.576 22 7v15l-4-4zm-5-1V3q0-.424.288-.712A.97.97 0 0 1 3 2h13q.424 0 .712.288Q17 2.575 17 3v9q0 .424-.288.713A.97.97 0 0 1 16 13H6z"
      })
    ], -1)
  ]))]))
}
export default { render: render }